import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustFeatures = [
    { icon: 'Shield', title: 'Sécurité garantie', description: 'Vos données sont protégées selon les normes RGPD', color: '#3b82f6' },
    { icon: 'Lock', title: 'Connexion sécurisée', description: 'Chiffrement SSL 256 bits pour toutes les transactions', color: '#3b82f6' },
    { icon: 'CheckCircle', title: 'Certifié professionnel', description: 'Entreprise certifiée Qualibat et RGE', color: '#22c55e' },
    { icon: 'Clock', title: 'Support 24/7', description: 'Assistance disponible à tout moment', color: '#eab308' }
  ];

  const certifications = [
    { name: 'RGPD', icon: 'FileCheck', color: '#22c55e' },
    { name: 'Qualibat', icon: 'Award', color: '#3b82f6' },
    { name: 'RGE', icon: 'Leaf', color: '#22c55e' },
    { name: 'ISO 9001', icon: 'BadgeCheck', color: '#3b82f6' }
  ];

  return (
    <div className="space-y-6">
      <div className="glass-panel rounded-2xl p-6">
        <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
          <Icon name="ShieldCheck" size={24} style={{ color: "#3b82f6" }} />
          Pourquoi nous faire confiance ?
        </h3>
        
        <div className="space-y-4">
          {trustFeatures?.map((feature, index) => (
            <div key={index} className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(59, 130, 246, 0.15)" }}>
                <Icon name={feature?.icon} size={20} style={{ color: feature.color }} />
              </div>
              <div>
                <h4 className="text-sm font-medium text-white mb-1">
                  {feature?.title}
                </h4>
                <p className="text-xs text-gray-400">
                  {feature?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="glass-panel rounded-2xl p-6">
        <h3 className="text-sm font-medium text-white mb-4">
          Certifications et conformité
        </h3>
        
        <div className="grid grid-cols-2 gap-3">
          {certifications?.map((cert, index) => (
            <div key={index} className="rounded-lg p-3 flex items-center gap-2" style={{ background: "rgba(17, 24, 39, 0.5)" }}>
              <Icon name={cert?.icon} size={16} style={{ color: cert.color }} />
              <span className="text-xs font-medium text-gray-300">
                {cert?.name}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-xl p-4" style={{ background: "rgba(59, 130, 246, 0.1)", border: "1px solid rgba(59, 130, 246, 0.3)" }}>
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} style={{ color: "#3b82f6" }} />
          <div>
            <h4 className="text-sm font-medium text-white mb-1">
              Protection de vos données
            </h4>
            <p className="text-xs text-gray-400">
              Vos données et votre localisation ne sont partagées qu'avec votre accord explicite. Conformité totale RGPD.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;